import script from "./CrudMaquinas.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudMaquinas.vue?vue&type=script&setup=true&lang=js"

import "./CrudMaquinas.vue?vue&type=style&index=0&id=25c25d82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25c25d82"]])

export default __exports__